import axios from 'axios'
import { BASE_URL, API_VERSION, RAFFLES } from '../endpoints'

export const GET_ALL_RAFFLES = 'GET_ALL_RAFFLES'
export const GET_RAFFLE = 'GET_RAFFLE'
export const ADD_RAFFLE = 'ADD_RAFFLE'
export const EDIT_RAFFLE = 'EDIT_RAFFLE'
export const DELETE_RAFFLE = 'DELETE_RAFFLE'
export const CLEAR_RAFFLE = 'CLEAR_RAFFLE'

export const getAllItems = (page, size, search) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken');
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };

    return axios.get(`${BASE_URL}${RAFFLES}?page=${page}&size=${size}&search=${search}&admin=true`, options)
        .then((response) => {

            dispatch({
                type: GET_ALL_RAFFLES,
                payload: {
                    raffles: response.data.data,
                    total: response.data.data.totalElements // Adjust based on API
                }
            });
            return Promise.resolve(response.data.data);
        })
        .catch((error) => {
            return Promise.reject(error.response?.data?.error);
        });
};

export const getItem = (id) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken');
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };

    return axios.get(`${BASE_URL}${RAFFLES}/${id}`, options)
        .then((response) => {

            dispatch({
                type: GET_RAFFLE,
                payload: {
                    raffle: response.data.data,
                }
            });
            return Promise.resolve(response.data.data);
        })
        .catch((error) => {
            return Promise.reject(error.response?.data?.error);
        });
};

export const getItemLocal = (data) => (dispatch) => {
    dispatch({
        type: GET_RAFFLE,
        payload: {
            raffle: data,
        }
    });
};


export const addItem = (payload) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken')
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ` + accessToken,
        }
    }
    return axios.post(BASE_URL + RAFFLES, payload, apiHeader)
        .then(response => {
            // dispatch({ type: ADD_RAFFLE, payload: response.data });
            return Promise.resolve()
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const deleteItem = (id) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken')
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };
    return axios.delete(BASE_URL + RAFFLES + '/' + id, apiHeader)
        .then(response => {
            // dispatch({ type: DELETE_RAFFLE, payload: id });
            return Promise.resolve(response.data)
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const editItem = (id, payload) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken')
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };
    return axios.patch(BASE_URL + RAFFLES + '/' + id, payload, apiHeader)
        .then(response => {
            dispatch({
                type: GET_RAFFLE,
                payload: {
                    raffle: response.data.data[0],
                }
            });
            return Promise.resolve()
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const clearItem = () => (dispatch) => {
    dispatch({ type: CLEAR_RAFFLE });
}